var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('footer', {
    staticClass: "footer footer-bar mt-5"
  }, [_c('div', {
    staticClass: "container text-center"
  }, [_c('div', {
    staticClass: "row align-items-center"
  }, [_vm._m(0), _c('div', {
    staticClass: "col-sm-6 mt-4 mt-sm-0 pt-2 pt-sm-0"
  }, [_c('ul', {
    staticClass: "list-unstyled text-sm-right mb-0"
  }, [_c('li', {
    staticClass: "list-inline-item mr-2"
  }, [_c('b-link', {
    staticClass: "text-muted",
    attrs: {
      "href": "https://brevisvelox.com/#/terms",
      "target": "_blank"
    }
  }, [_vm._v(_vm._s(_vm.$t("footer.terms")))])], 1), _c('li', {
    staticClass: "list-inline-item"
  }, [_c('b-link', {
    staticClass: "text-muted",
    attrs: {
      "href": "https://brevisvelox.com/#/privacy",
      "target": "_blank"
    }
  }, [_vm._v(_vm._s(_vm.$t("footer.privacy")))])], 1), _vm._m(1)])])])])]);
}
var staticRenderFns = [function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', {
    staticClass: "col-sm-6"
  }, [_c('div', {
    staticClass: "text-sm-left"
  }, [_c('p', {
    staticClass: "mb-0"
  }, [_vm._v(" © 2021 BrevisVelox ")])])]);
},function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('li', {
    staticClass: "list-inline-item ml-5 text-muted"
  }, [_vm._v(" Powered by: "), _c('a', {
    attrs: {
      "href": "https://techsumo.eu",
      "title": "TechSumo",
      "target": "_blank"
    }
  }, [_c('img', {
    staticClass: "img-fluid mb-2",
    attrs: {
      "src": require("@/assets/images/techsumo_icon_50.png"),
      "alt": "TechSumo",
      "width": "25",
      "height": "auto"
    }
  })])]);
}]

export { render, staticRenderFns }